import {LifeProject} from './life-project';
import {Person} from '../person';
import {UniversityPlan} from '../config/university-plan';

export class UniversityProject extends LifeProject {
  child: Person;
  selectedPlan: UniversityPlan;
  tax: number;
  type = 0;
}
